import React, { useState } from "react";
import { connect } from "react-redux";
// import AddIcon from "@material-ui/icons/Add";
// import BackupOutlinedIcon from "@material-ui/icons/BackupOutlined";
// import { makeStyles } from "@material-ui/core/styles";
// import Button from "@material-ui/core/Button";
import "./SavestTitle.css";
import { showModal } from "../../../../../redux/actions/modal.action";

import { useUser } from "../../../../../hooks/use-user";
// import CreateSavestIndex from "./SavestModal/CreateSavestModal/CreateSavestIndex"

// const useStyles = makeStyles((theme) => ({
//   button: {
//     margin: theme.spacing(1),
//   },
// }));
const SavestTitle = ({ toggleModalAppearance }) => {
  const user = useUser();
  const [savestTransactionActive] = useState(false);
  // const classes = useStyles();
  // const openModal = () => {
  //   toggleModalAppearance();
  //   console.log("open redux");
  // };

  if (!user) {
    return null;
  }

  return (
    <div className="savest">
      <div className="savestPage">
        <div className="SavestHeader">
          <h1>Savest</h1>
          <p className="">
            Hi {user.lastname}, let’s help you save towards a goal
          </p>
        </div>
       
      </div>
      </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  toggleModalAppearance: () => dispatch(showModal()),
  // toggleWithdrawalModalAppearance: () => dispatch(showWithdrawalModal()),
});
export default connect(null, mapDispatchToProps)(SavestTitle);
